export default props => {
  return (
    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 8.5L8 1.5L1 8.5" stroke="black" />
    </svg>
  )
}
